import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
    cardContentMarkerIcons: {
        position: 'absolute',
        right: 8,
        bottom: 8,
    },
    liveCard: {
        bottom: 20,
    },
    noMarginRight: {
        marginRight: 0,
    },
    rowContentMarkerIcons: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
    },
});

export default styles;
